(function () {
	try {
			// Prevent multiple loads if QM already present on the page (prod/test).
			var existing = document.querySelector(
				'script[src^="https://cdn.quantummetric.com/qscripts/quantum-pultegroup"]'
			);
			if (existing) return;

			// Prevent multiple loads (this loader)
			if (typeof window !== 'undefined' && window.__qmLoaded) return;
			
			var src = 'https://cdn.quantummetric.com/qscripts/quantum-pultegroup.js';

			var script = document.createElement('script');
			script.async = true;
			script.src = src;

			script.onerror = function () {
				if (
					typeof window !== 'undefined' &&
					window.console &&
					typeof window.console.error === 'function'
				) {
					window.console.error('QM script failed to load:', script.src);
				}
			};
		
			// Mark as loaded by this loader only when we actually inject.
			if (typeof window !== 'undefined') {
				window.__qmLoaded = true;
			}

			(document.body || document.head || document.documentElement).appendChild(script);
	}
	catch (e) {
		if (
			typeof window !== 'undefined' &&
			window.console &&
			typeof window.console.warn === 'function'
		) {
			window.console.warn('QM injection error:', e);
		}
	}
})();
